<div
  class="network-background"
  [style.background-image]="
    'url(' +
    (isDarkMode()
      ? 'assets/shell/backgrounds/nebula-enterprise-dark.png'
      : 'assets/shell/backgrounds/nebula-enterprise-light.png') +
    ')'
  "
></div>
<div class="background-overlay" [class.background-overlay--dark]="isDarkMode()"></div>

@if (perfil30) {
  <div class="selector30">
    <nav class="selector30__pasos" [attr.aria-label]="'SELECTOR.STEPS' | translate">
      <button type="button" class="selector30__paso selector30__paso--hecho" (click)="onBack()">
        <span class="selector30__marca"><i-lucide name="Check" [size]="12"></i-lucide></span>
        <span class="selector30__paso-rotulo">{{ 'SELECTOR.STEP_COMPANY' | translate }}</span>
        @if (empresa) {
          <span class="selector30__paso-valor">{{ empresa }}</span>
        }
      </button>
      <i-lucide class="selector30__flecha" name="ChevronRight" [size]="12"></i-lucide>
      <span class="selector30__paso selector30__paso--activo">
        <span class="selector30__marca"><i-lucide name="Dot" [size]="14"></i-lucide></span>
        <span class="selector30__paso-rotulo">{{ 'SELECTOR.STEP_MODULE' | translate }}</span>
      </span>
    </nav>

    <div class="selector30__encabezado">
      <div class="selector30__encabezado-texto">
        <h1 class="selector30__titulo">
          {{ 'PRODUCTS.GREETING' | translate: { name: username } }}
        </h1>
        <p class="selector30__entrada">
          {{ 'PRODUCTS.SUBTITLE' | translate }}
          @if (empresa) {
            {{ 'SELECTOR.WORKING_ON' | translate: { empresa: empresa } }}
          }
        </p>
      </div>
      <button type="button" class="selector30__cambiar" (click)="onBack()">
        <i-lucide name="ArrowLeft" [size]="14"></i-lucide>
        {{ 'SELECTOR.CHANGE_COMPANY' | translate }}
      </button>
    </div>

    <div class="selector30__barra">
      <div class="selector30__buscador">
        <lib-input
          [value]="searchTerm()"
          (valueChange)="onSearchChange($event)"
          [placeholder]="'SELECTOR.MODULE_SEARCH' | translate"
          [clearable]="true"
          suffixIcon="Search"
          [attr.aria-label]="'SELECTOR.MODULE_SEARCH' | translate"
          [label]="'SELECTOR.MODULE_SEARCH' | translate"
        ></lib-input>
      </div>
      <span class="selector30__conteo">{{ conteo() }}</span>
    </div>

    @if (filteredModules().length > 0) {
      <!-- El diseño lo elige la compañia (APARIENCIA.selectorProducto); el actual es el de siempre. -->
      @switch (disenoSelector()) {
        @case ('LISTA_DETALLE') {
          <div class="selector30__maestro">
            <div class="selector30__lista selector30__lista--maestro">
              <div class="selector30__maestro-cabeza">
                <span class="selector30__maestro-titulo">{{
                  'LAYOUT.MENU.PRODUCTS' | translate
                }}</span>
                <span>{{ filteredModules().length }}</span>
              </div>
              @for (modulo of filteredModules(); track modulo.id) {
                <button
                  type="button"
                  class="selector30__opcion"
                  [class.selector30__opcion--marcada]="modulo.id === productoEnDetalle()?.id"
                  [attr.aria-pressed]="modulo.id === productoEnDetalle()?.id"
                  (click)="marcarProducto(modulo)"
                >
                  <span class="selector30__sello selector30__sello--opcion"
                    ><i-lucide [name]="modulo.icon" [size]="18"></i-lucide
                  ></span>
                  <span class="selector30__opcion-textos">
                    <span class="selector30__opcion-nombre">{{ modulo.title }}</span>
                    <span class="selector30__opcion-conteo">{{ conteoDeProcesos(modulo) }}</span>
                  </span>
                  @if (modulo.id === productoEnDetalle()?.id) {
                    <i-lucide name="ChevronRight" [size]="18"></i-lucide>
                  }
                </button>
              }
            </div>
            @if (productoEnDetalle(); as detalle) {
              <div class="selector30__columna-detalle">
                <section class="selector30__detalle">
                  <span class="selector30__sello selector30__sello--detalle"
                    ><i-lucide [name]="detalle.icon" [size]="32"></i-lucide
                  ></span>
                  <div class="selector30__detalle-textos">
                    <h2 class="selector30__detalle-nombre">{{ detalle.title }}</h2>
                    @if (detalle.subtitle) {
                      <p class="selector30__detalle-desc">{{ detalle.subtitle }}</p>
                    }
                  </div>
                  <lib-button
                    variant="primary"
                    suffixIcon="ArrowRight"
                    (clicked)="entrarAlModulo(detalle)"
                  >
                    {{ 'SELECTOR.ENTER' | translate }}
                  </lib-button>
                </section>
                @if (accesosDirectos().length > 0) {
                  <div class="selector30__accesos-cabeza">
                    <i-lucide name="LayoutGrid" [size]="18"></i-lucide>
                    <span class="selector30__maestro-titulo">{{
                      'SELECTOR.GO_DIRECT' | translate
                    }}</span>
                    <span>· {{ conteoDeProcesos(detalle) }}</span>
                  </div>
                  <div class="selector30__accesos">
                    @for (acceso of accesosDirectos(); track acceso.opcion.ruta) {
                      <button
                        type="button"
                        class="selector30__acceso"
                        [class.selector30__acceso--grande]="acceso.grande"
                        [title]="acceso.opcion.nombre"
                        (click)="entrarAOpcion(detalle, acceso.opcion)"
                      >
                        <span class="selector30__acceso-cabeza">
                          <span class="selector30__sello selector30__sello--acceso"
                            ><i-lucide
                              [name]="acceso.opcion.icono"
                              [size]="acceso.grande ? 28 : 20"
                            ></i-lucide
                          ></span>
                          <i-lucide
                            class="selector30__acceso-flecha"
                            name="ArrowUpRight"
                            [size]="18"
                          ></i-lucide>
                        </span>
                        <span class="selector30__acceso-nombre">{{ acceso.opcion.nombre }}</span>
                      </button>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
        @case ('ICONO_CENTRADO') {
          <div class="selector30__centrados">
            @for (modulo of filteredModules(); track modulo.id) {
              <div
                role="button"
                tabindex="0"
                class="selector30__centrado"
                [matTooltip]="modulo.subtitle"
                matTooltipClass="lib-custom-tooltip"
                matTooltipPosition="above"
                (click)="entrarAlModulo(modulo)"
                (keydown.enter)="entrarAlModulo(modulo)"
              >
                @if (modulo.opciones?.length) {
                  <span class="selector30__centrado-conteo">{{ conteoDeProcesos(modulo) }}</span>
                }
                <span class="selector30__sello selector30__sello--centrado"
                  ><i-lucide [name]="modulo.icon" [size]="40"></i-lucide
                ></span>
                <span class="selector30__centrado-nombre">{{ modulo.title }}</span>
                <span class="selector30__centrado-accesos">
                  @for (opcion of accesosDeTarjeta(modulo, maximoAccesosIcono); track opcion.ruta) {
                    <button
                      type="button"
                      class="selector30__centrado-acceso"
                      [title]="opcion.nombre"
                      (click)="$event.stopPropagation(); entrarAOpcion(modulo, opcion)"
                      (keydown.enter)="$event.stopPropagation()"
                    >
                      {{ opcion.nombre }}
                    </button>
                  }
                </span>
              </div>
            }
          </div>
        }
        @case ('MOSAICO') {
          <div class="selector30__mosaico">
            @for (pieza of mosaico(); track pieza.modulo.id) {
              <button
                type="button"
                [class]="'selector30__pieza selector30__pieza--' + pieza.tono"
                [style.grid-column]="'span ' + pieza.columnas"
                [style.grid-row]="'span ' + pieza.filas"
                [title]="pieza.modulo.subtitle"
                (click)="entrarAlModulo(pieza.modulo)"
              >
                <span class="selector30__pieza-cabeza">
                  <i-lucide
                    [name]="pieza.modulo.icon"
                    [size]="pieza.filas === 2 ? 48 : 28"
                  ></i-lucide>
                  @if (pieza.modulo.opciones?.length) {
                    <span class="selector30__pieza-conteo">{{
                      conteoDeProcesos(pieza.modulo)
                    }}</span>
                  }
                </span>
                <span class="selector30__pieza-textos">
                  <span
                    class="selector30__pieza-nombre"
                    [class.selector30__pieza-nombre--grande]="pieza.filas === 2"
                    >{{ pieza.modulo.title }}</span
                  >
                  @if (pieza.modulo.subtitle) {
                    <span class="selector30__pieza-desc">{{ pieza.modulo.subtitle }}</span>
                  }
                </span>
              </button>
            }
          </div>
        }
        @default {
          <div class="selector30__rejilla">
            @for (modulo of filteredModules(); track modulo.id) {
              <button type="button" class="selector30__tarjeta" (click)="entrarAlModulo(modulo)">
                <span class="selector30__cabeza">
                  <span class="selector30__sello"
                    ><i-lucide [name]="modulo.icon" [size]="17"></i-lucide
                  ></span>
                  <span class="selector30__nombre">{{ modulo.title }}</span>
                </span>
                @if (modulo.subtitle) {
                  <span class="selector30__desc">{{ modulo.subtitle }}</span>
                }
                <span class="selector30__pie">
                  <span class="selector30__entrar">
                    {{ 'SELECTOR.ENTER' | translate }}
                    <i-lucide name="ArrowRight" [size]="11"></i-lucide>
                  </span>
                </span>
              </button>
            }
          </div>
        }
      }
    } @else {
      <div class="selector30__vacio">
        <i-lucide name="LayoutGrid" [size]="24"></i-lucide>
        <p class="selector30__vacio-titulo">
          {{ 'SELECTOR.MODULE_EMPTY_TITLE' | translate: { termino: searchTerm() } }}
        </p>
        <p class="selector30__vacio-pie">{{ 'SELECTOR.MODULE_EMPTY_HINT' | translate }}</p>
      </div>
    }
  </div>
} @else {
  <div class="products-container">
    <header class="products-header">
      <div class="header-content">
        <h1 class="page-title">
          <div class="title-wrapper">
            <div class="back-action">
              @if (!showBackButton()) {
                <lib-button
                  variant="primary"
                  prefixIcon="CircleArrowLeft"
                  (clicked)="onBack()"
                  (keydown.enter)="onBack()"
                  width="100px"
                  hidden="20px"
                  class="btn-back-button"
                  tabindex="0"
                >
                  {{ 'ACTIONS.BACK' | translate }}
                </lib-button>
              }
            </div>
            <div>
              <span class="page-resume">
                {{ 'PRODUCTS.GREETING' | translate: { name: username } }}</span
              >
              <span class="page-subtitle"> {{ 'PRODUCTS.SUBTITLE' | translate }} </span>
            </div>
          </div>
        </h1>
      </div>
    </header>

    <div class="search-products">
      <lib-input
        [value]="searchTerm()"
        (valueChange)="onSearchChange($event)"
        [placeholder]="'LAYOUT.SEARCH_PLACEHOLDER' | translate"
        [clearable]="false"
        suffixIcon="Search"
        [attr.aria-label]="'LAYOUT.SEARCH_PLACEHOLDER' | translate"
        [label]="'LAYOUT.SEARCH_PLACEHOLDER' | translate"
        [attr.aria-describedby]="'search-description'"
        [attr.aria-required]="'false'"
        tabindex="0"
      ></lib-input>
    </div>

    <div class="modules-grid">
      <section class="grid-content">
        @if (filteredModules().length > 0) {
          <lib-gridcard
            [items]="filteredModules()"
            (cardClick)="selectProduct($event)"
          ></lib-gridcard>
        } @else {
          <div class="empty-wrapper">
            <lib-empty
              [message]="'PRODUCTS.EMPTY' | translate"
              [description]="'COMMON.EMPTY_HINT' | translate"
            ></lib-empty>
          </div>
        }
      </section>
    </div>
  </div>
}
